import { render, staticRenderFns } from "./SitePreference.vue?vue&type=template&id=bf73afb4"
import script from "./SitePreference.vue?vue&type=script&lang=js"
export * from "./SitePreference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf73afb4')) {
      api.createRecord('bf73afb4', component.options)
    } else {
      api.reload('bf73afb4', component.options)
    }
    module.hot.accept("./SitePreference.vue?vue&type=template&id=bf73afb4", function () {
      api.rerender('bf73afb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sl/ApplicationCCL/Form/SitePreference.vue"
export default component.exports